module.exports = __webpack_public_path__ + "static/media/export.c1811139.svg";